module.exports = __webpack_public_path__ + "img/guest.3425b091.png";